import Button from "devextreme-react/button";
import { confirm } from 'devextreme/ui/dialog';
import { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { WorkOrderContext } from "../context/WorkOrderContext";

export default function ExitButton() {

	const navigate = useNavigate();
	let [params] = useSearchParams();
	const returnUrl = params.get("returnUrl");

	const { order } = useContext(WorkOrderContext);

	return (
		<Button
			text="Exit"
			icon="Inscyth-Exit"
			visible={!!returnUrl}
			type="danger"
			onClick={() => {
				if (order.modified) {
					let result = confirm("There are some unsaved changes on the page, are you sure you want to exit?",
						"Unsaved Changes");
					result.then(function (dialogResult) {
						if (dialogResult)
							navigate(returnUrl!);
					});
				}
				else {
					navigate(returnUrl!);
				}
			}} >
		</Button>
	)
}
